import { Fragment, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Grid, Button, Card, CardContent, CardHeader, Divider, Typography, TextField, List, ListItem, ListItemText, FormControl, InputLabel, MenuItem, Select, FormControlLabel, FormLabel, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TablePaginationActions, TableRow, Box, Tab, Tabs, Dialog, DialogActions, DialogContent, DialogTitle, ListItemButton, CircularProgress } from "@mui/material";

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import moment from 'moment';
import "moment/locale/es-mx";

import { TabPanel, TabProps } from '../../../helpers/TabPanel';

import { usePages } from '../../../hooks/usePages';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../../styles/TableStyle';

import { Layout } from "../../../components/Layout";

import { Digitalizar } from './Digitalizar';

import { DialogDocumento } from '../../../dialogs/DialogDocumento';

import { ObtenerAutoridadesMaterias } from '../../../connections/catalogos/AutoridadConnection';
import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';
import { ObtenerTipoJuicio } from '../../../connections/catalogos/TipoJuicioConnection';
import { ObtenerEtapa } from '../../../connections/catalogos/EtapaConnection';
import { ObtenerSubEtapa } from '../../../connections/catalogos/SubEtapaConnection';
import { BuscarExpedienteAnterior, GuardarExpedienteAnterior, ObtenerDigitalizacion } from '../../../connections/recepcion/ExpedienteConnection';

import { AutoridadProps } from '../../../interfaces/catalogos/AutoridadInterface';
import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { TipoJuicioProps } from '../../../interfaces/catalogos/TipoJuicioInterface';
import { EtapaProps } from '../../../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../../../interfaces/catalogos/SubEtapaInterface';
import { defaultExpedienteAnteriorResponse, DigitalizacionProps, ExpedienteAnteriorParteProps, ExpedienteAnteriorProps, GuardarExpedienteAnteriorParams } from '../../../interfaces/recepcion/ExpedienteInterface';

export const ImportarExpedientePage = () => {

    const dispatch = useDispatch();

    const [expedienteEncontrado, setExpedienteEncontrado] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [tipoJuicio, setTipoJuicio] = useState( 0 );
    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );

    const [etapa, setEtapa] = useState( 0 );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );

    const [subEtapa, setSubEtapa] = useState( 0 );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );

    const [tipoSentencia, setTipoSentencia] = useState( 0 );
    const [fechaCitacion, setFechaCitacion] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const [fechaConclusion, setFechaConclusion] = useState( moment( new Date() ).format( 'YYYY-MM-DD' ) );

    const [expediente, setExpediente] = useState<ExpedienteAnteriorProps>( defaultExpedienteAnteriorResponse );
    const [partes, setPartes] = useState<ExpedienteAnteriorParteProps[]>( [] );

    const [value, setValue] = useState( 0 );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [loadingDigitalizacion, setLoadingDigitalizacion] = useState( false );
    const [openDigitalizacion, setOpenDigitalizacion] = useState( false );
    const [digitalizaciones, setDigitalizaciones] = useState<DigitalizacionProps[]>( [] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(5);

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue )

    const handleBuscar = async () => {

        setLoading( true );

        await BuscarExpedienteAnterior({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setExpedienteEncontrado( true );
                    setNumeroExpediente( '' );
                    setMateria( 0 );
                    setAutoridad( 0 );

                    setExpediente( resp );
                    setPartes( resp.partes ?? [] );
                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'success' }) );

                }
                else {

                    handleClear();
                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleClear = () => {

        setExpedienteEncontrado( false );
        setNumeroExpediente( '' );
        setMateria( 0 );
        setAutoridad( 0 );
        setTipoJuicio( 0 );

        setSubEtapa( 0 );
        setSubEtapaArray( [] );
        setTipoSentencia( 0 );
        setFechaCitacion( moment( new Date() ).format( 'YYYY-MM-DD' ) );

        setExpediente( defaultExpedienteAnteriorResponse );
        setPartes( [] );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        const params: GuardarExpedienteAnteriorParams = {
            idTipoJuicio: tipoJuicio,
            idTipoSentencia: tipoSentencia,
            fechaCitacion: fechaCitacion,
            fechaConclusion: fechaConclusion,
            idEtapa: etapa,
            idSubEtapa: subEtapa,
            idAutoridad: expediente.idAutoridad ?? 0,
            numeroExpediente: expediente.numeroExpediente ?? '',
            numeroFolio: expediente.numeroFolio ?? '',
            referencia: expediente.referencia ?? 0,
            fechaPresentacion: expediente.fechaPresentacion,
            fechaRadicacion: expediente.fechaRadicacion,
            partes: expediente.partes ?? 0,
        };

        await GuardarExpedienteAnterior( params ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setExpediente({
                        ...expediente,
                        encontrado: true,
                    });

                    handleClear();
                    setLoadingGuardar( false );

                    dispatch( openSnackbar({ message, variant: 'success' }) );

                }
                else {

                    handleClear();
                    setLoadingGuardar( false );

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener(){

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        if ( materia !== 0 ) {

            Obtener();

        }

    }, [ materia ]);

    useEffect(() => {

        async function Obtener(){

            await ObtenerTipoJuicio().then( resp => {
                setTipoJuicioArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){

            setSubEtapa( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapa ).then( resp => {
                setSubEtapaArray( resp );
            });

        }

        Obtener();

    }, [ etapa ]);

    useEffect(() => {

        async function Obtener(){

            setLoadingDigitalizacion( true );
            setDigitalizaciones( [] );

            await ObtenerDigitalizacion( expediente.idExpediente ).then( resp => {

                setTimeout(() => {

                    setLoadingDigitalizacion( false );
                    setDigitalizaciones( resp );

                }, 700);

            });

        }

        if ( expediente.idExpediente !== 0 && openDigitalizacion ) {

            Obtener();

        }
        else {

            setLoadingDigitalizacion( false );
            setDigitalizaciones( [] );

        }

    }, [ expediente.idExpediente, openDigitalizacion ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Importar' }, { text: 'Importar expediente' }] } backgroundPaper={ false }>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                <Tabs value={ value } onChange={ handleChange }>

                    <Tab label="Importar" {...TabProps( 0 )} />
                    <Tab label="Digitalizar" {...TabProps( 1 )} />

                </Tabs>

            </Box>

            <TabPanel value={ value } index={ 0 }>

                <Grid container spacing={ 3 } >

                    <Grid size={{ md: 4, xs: 12 }}>

                        <Grid container spacing={ 3 }>

                            <Grid size={{ md: 12, xs: 12 }}>

                                <Card>

                                    <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }/>

                                    <Divider />

                                    <CardContent sx={{ p: 3 }}>

                                        <Grid container spacing={ 3 } mt={ 1 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <TextField
                                                    fullWidth
                                                    label="Número de expediente"
                                                    variant="outlined"
                                                    placeholder={ `1/${ new Date().getFullYear() }` }
                                                    value={ numeroExpediente }
                                                    onChange={ (e) => setNumeroExpediente( e.target.value ) }
                                                    slotProps={{
                                                        input: {
                                                            autoComplete: 'off'
                                                        },
                                                        inputLabel: {
                                                            shrink: true,
                                                        }
                                                    }}
                                                />

                                            </Grid>

                                            <Grid size={{ xs: 12, md: 12 }}>

                                                <FormControl required fullWidth>

                                                    <InputLabel>Materia</InputLabel>

                                                    <Select
                                                        label="Materia"
                                                        value={ materia }
                                                        onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            materiaArray
                                                            .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                                            .map( ( e ) => (
                                                                <MenuItem key={ e.idMateria } value={ e.idMateria }>{ e.descripcion }</MenuItem>
                                                            ))
                                                        }

                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ xs: 12, md: 12 }}>

                                                <FormControl required fullWidth>

                                                    <InputLabel>Autoridad</InputLabel>

                                                    <Select
                                                        label="Autoridad"
                                                        value={ autoridad }
                                                        onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                                        disabled={ materia === 0 }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            autoridadArray
                                                            .filter( (e) => e.idAutoridad !== 6 )
                                                            .map( ( e ) => (
                                                                <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>
                                                            ))
                                                        }

                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                                                <Button
                                                    fullWidth
                                                    color={ 'primary' }
                                                    variant={ 'contained' }
                                                    onClick={ handleBuscar }
                                                    loading={ loading }
                                                    disabled={ numeroExpediente === '' || autoridad === 0 || loading }
                                                >
                                                    Buscar
                                                </Button>

                                            </Grid>

                                        </Grid>

                                    </CardContent>

                                </Card>

                            </Grid>

                        </Grid>

                    </Grid>

                    <Grid size={{ md: 8, xs: 12 }}>

                        <Card>

                            <CardHeader
                                sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                                subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Información del expediente </Typography> }
                            />

                            <Divider />

                            <CardContent sx={{ p: 3 }}>

                                <Grid container spacing={ 1 }>

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de folio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.numeroFolio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.numeroExpediente } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de radicación: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.fechaRadicacion ? moment( expediente.fechaRadicacion ).format( 'DD-MM-YYYY' ) : '' } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        expediente.tipoJuicio
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                            secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.tipoJuicio } </Typography> }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        expediente.etapa
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Etapa: </Typography> }
                                                            secondary={
                                                                expediente.subEtapa
                                                                ?
                                                                    <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.etapa } ({ expediente.subEtapa }) </Typography>
                                                                :
                                                                    <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.etapa } </Typography>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Juez(a): </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.juez } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Juzgado de origen: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.juzgado }</Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Presentante: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.presentante } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de presentación: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.fechaPresentacion ? moment( expediente.fechaPresentacion ).format( 'DD-MM-YYYY' ) : '' } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Sintesís: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { expediente.sintesis } </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        expediente.idExpediente !== 0
                                        &&
                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => setOpenDigitalizacion( true ) }
                                                >
                                                    Ver digitalización
                                                </Button>

                                            </Grid>
                                    }

                                    <Grid size={{ md: 12, xs: 12 }}>

                                        <TableContainer sx={{ borderRadius: 3, mt: 1 }}>

                                            <Table>

                                                <TableHead sx={{ ...TableTheadStyle }}>

                                                    <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '50%', fontWeight: 'bold' }}>Nombre</TableCell>
                                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Tipo de parte</TableCell>
                                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold', textAlign: 'center' }}>¿Es persona moral?</TableCell>

                                                    </TableRow>

                                                </TableHead>

                                                <TableBody>

                                                {
                                                    (   rowsPerPage > 0
                                                        ? partes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : partes
                                                    ).map( ( row, index ) => (

                                                        <TableRow key={ index } >
                                                            <TableCell> { row.nombre } { row.apellidoPaterno } { row.apellidoMaterno } </TableCell>
                                                            <TableCell> { row.tipo } </TableCell>
                                                            <TableCell sx={{ textAlign: 'center' }}> { row.personaMoral === 1 ? 'Si' : 'No' } </TableCell>
                                                        </TableRow>

                                                    ))
                                                }

                                                {
                                                    ( partes.length === 0 && expedienteEncontrado )
                                                    &&
                                                        <TableRow>
                                                        <TableCell
                                                                colSpan={ 7 }
                                                                align="center"
                                                            >
                                                                <Typography variant="caption" color='secondary'> No se encontraron partes </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                }

                                                </TableBody>

                                                <TableFooter>

                                                    <TableRow>

                                                        <TablePagination
                                                            rowsPerPageOptions={ [] }
                                                            colSpan={ 3 }
                                                            count={ partes.length }
                                                            rowsPerPage={ rowsPerPage }
                                                            page={ page }
                                                            onPageChange={ handleChangePage }
                                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                                            ActionsComponent={ TablePaginationActions }
                                                            labelDisplayedRows={
                                                                ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                                }
                                                            }
                                                        />

                                                    </TableRow>

                                                </TableFooter>

                                            </Table>

                                        </TableContainer>

                                    </Grid>

                                </Grid>

                                {
                                    ( expedienteEncontrado && !expediente.encontrado )
                                    &&
                                        <Grid container spacing={ 3 } mt={ 3 }>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <FormControl fullWidth>
                                                    <InputLabel>Tipo de juicio</InputLabel>

                                                    <Select
                                                        label="Tipo de juicio"
                                                        value={ tipoJuicio }
                                                        onChange={ (e) => setTipoJuicio( e.target.value ) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            tipoJuicioArray.map( ({ idTipoJuicio, descripcion }) => (
                                                                <MenuItem key={ idTipoJuicio } value={ idTipoJuicio }>{ descripcion }</MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <FormControl fullWidth>
                                                    <InputLabel>Etapa</InputLabel>

                                                    <Select
                                                        label="Etapa"
                                                        value={ etapa }
                                                        onChange={ (e) => setEtapa( e.target.value ) }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            etapaArray.map( ({ idEtapa, descripcion }) => (
                                                                <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <FormControl fullWidth>
                                                    <InputLabel>Sub etapa</InputLabel>

                                                    <Select
                                                        label="Sub etapa"
                                                        value={ subEtapa }
                                                        onChange={ (e) => setSubEtapa( e.target.value ) }
                                                        disabled={ etapa === 0 || subEtapaArray.length === 0 }
                                                    >
                                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                        {
                                                            subEtapaArray.map( ({ idSubEtapa, descripcion }) => (
                                                                <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            {
                                                etapa === 12
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <FormControl>
                                                            <FormLabel sx={{ color: 'black' }}>Seleccione el tipo de sentencia:</FormLabel>
                                                            <RadioGroup row>

                                                                <FormControlLabel
                                                                    value="SentenciaDefinitiva"
                                                                    label="Sentencia Definitiva"
                                                                    control={
                                                                        <Radio
                                                                            checked={ tipoSentencia === 1 }
                                                                            onChange={ () => setTipoSentencia( 1 ) }
                                                                        />
                                                                    }
                                                                />

                                                                <FormControlLabel
                                                                    value="SentenciaInterlocutoria"
                                                                    label="Sentencia Interlocutoria"
                                                                    control={
                                                                        <Radio
                                                                            checked={ tipoSentencia === 2 }
                                                                            onChange={ () => setTipoSentencia( 2 ) }
                                                                        />
                                                                    }
                                                                />

                                                            </RadioGroup>
                                                        </FormControl>

                                                    </Grid>
                                            }

                                            {
                                                etapa === 12
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                            <DatePicker
                                                                label="Fecha citación de sentencia"
                                                                sx={{ width: '100%' }}
                                                                value={ moment( fechaCitacion ) }
                                                                maxDate={ moment( new Date() ) }
                                                                onChange={ (e) => setFechaCitacion( moment( e ).format( 'YYYY-MM-DD' ) ) }
                                                            />

                                                        </LocalizationProvider>

                                                    </Grid>
                                            }

                                            {
                                                ( etapa === 3 && subEtapa !== 4 )
                                                &&
                                                    <Grid size={{ md: 12, xs: 12 }}>

                                                        <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es">

                                                            <DatePicker
                                                                label="Fecha conclusión"
                                                                sx={{ width: '100%' }}
                                                                value={ moment( fechaConclusion ) }
                                                                maxDate={ moment( new Date() ) }
                                                                onChange={ (e) => setFechaConclusion( moment( e ).format( 'YYYY-MM-DD' ) ) }
                                                            />

                                                        </LocalizationProvider>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ textAlign: 'center' }} mt={ 3 }>

                                                <Button
                                                    variant="contained"
                                                    loading={ loadingGuardar }
                                                    onClick={ handleGuardar }
                                                    disabled={
                                                        tipoJuicio === 0 ||
                                                        etapa === 0 ||
                                                        ( etapa === 0 && subEtapa === 0 && subEtapaArray.length !== 0 ) ||
                                                        ( etapa === 12 && tipoSentencia === 0 )
                                                    }
                                                >
                                                    Guardar expediente
                                                </Button>

                                            </Grid>

                                        </Grid>
                                }

                            </CardContent>

                        </Card>

                    </Grid>

                </Grid>

            </TabPanel>

            <TabPanel value={ value } index={ 1 }>

                <Digitalizar expediente={ expediente } />

            </TabPanel>

            <Dialog
                fullWidth
                maxWidth="sm"
                open={ openDigitalizacion }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Digitalización(es)
                </DialogTitle>

                <DialogContent>

                    {
                        ( !loadingDigitalizacion && digitalizaciones?.length === 0 )
                        &&
                            <Box textAlign='center' py={ 4 }>

                                <Typography variant="caption" color="text.secondary">
                                    No se encontraron registros
                                </Typography>

                            </Box>
                    }

                    {
                        loadingDigitalizacion
                        &&
                            <Box display="flex" justifyContent="center" alignItems="center" py={ 4 }>
                                <CircularProgress size={ 28 } />
                            </Box>
                    }

                    <List disablePadding>

                    {
                        digitalizaciones?.map( ( { url, fecha }, i ) => (

                            <Fragment key={ i }>

                                <ListItemButton
                                    onClick={ () => { setDocumento(url); setOpenDocumento(true); } }
                                >

                                    <ListItemText
                                        primary={ <Typography variant="h6">Digitalización</Typography> }
                                        secondary={ <Typography variant="caption" color="text.secondary">{ fecha ? moment(fecha).format('DD-MM-YYYY HH:mm') : '' }</Typography> }
                                    />

                                    <ChevronRightIcon fontSize="small" sx={{ color: 'text.disabled' }} />

                                </ListItemButton>

                                { i < digitalizaciones.length - 1 && <Divider component="li" /> }

                            </Fragment>

                        ))
                    }

                    </List>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" onClick={ () => setOpenDigitalizacion( false ) }>
                        Cerrar
                    </Button>

                </DialogActions>

            </Dialog>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

        </Layout>
    )
}
